// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__16nhw","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__-7jrN"};